// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ServicesPage from "../pages/Services/Services";
const __wvcRoutePaths = ["/ServicesPage", "/services"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["about-riverbend", "aboutriverbendpage", "contact", "contactpage", "home", "homepage", "insights", "insightspage", "our-team", "post", "services", "servicespage", "teamandcareerspage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<ServicesPage />} />
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<ServicesPage />} />
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
